// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2Dt9K","empty":"ModalGraph_empty__3DXek"};